var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7126 35.1321L17.7124 35.1323C17.2818 35.5377 16.7096 35.7585 16.1183 35.7472C15.527 35.7359 14.9637 35.4936 14.5489 35.0722L17.7126 35.1321ZM17.7126 35.1321L41.0068 13.1774L17.7126 35.1321ZM6.67644 27.0822L14.5487 35.0719L40.7257 10.7366L41.0897 10.3938C41.0897 10.3937 41.0896 10.3936 41.0895 10.3936C40.9123 10.2054 40.6996 10.054 40.4638 9.94793C40.228 9.84187 39.9735 9.78333 39.715 9.77565C39.4564 9.76797 39.1989 9.81131 38.9572 9.90318C38.7154 9.99504 38.4941 10.1336 38.306 10.311C38.3059 10.3111 38.3059 10.3111 38.3059 10.3111L16.2047 31.1432L9.48028 24.3182L9.48032 24.3182L9.47453 24.3125C9.10595 23.9503 8.60975 23.7476 8.09302 23.748C7.57629 23.7485 7.08045 23.9521 6.71249 24.3149C6.34453 24.6777 6.13395 25.1706 6.1262 25.6872C6.11844 26.2039 6.31413 26.7029 6.67103 27.0766L6.67099 27.0766L6.67644 27.0822Z",
    fill: "#3A935B",
    stroke: "#3A935B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.75b639b2ca54cacdd9612401371c9778.svg";
export { ForwardRef as ReactComponent };